import Card from '@mui/material/Card';
import { FileAttachableType } from '@treadinc/horizon-api-spec';
import type { JSX } from 'react';
import { useFormContext } from 'react-hook-form';

import FileAttachments from '~formsShared/components/FileAttachments';

import type { ProjectFormSchemaInterface } from '../../projectFormSchema';
import { useProjectFormV2Context } from '../ProjectFormV2Context';

// Mirrors the legacy form — a render-only wrapper around the
// existing `<FileAttachments/>` shared widget. Do NOT fork the widget: it is
// the canonical implementation used by Projects, Orders, Jobs, and Loads.
// `defaultProject` flows in through context (set by the Provider from the
// dialog's `defaultProject` prop); the rest of the props are sourced from the
// Provider's `useFormContext()` — the same surface the legacy form pulled out
// of its own `useForm()` call. The `fileAttachmentsRef` is owned by the Context
// (mirrors the legacy form's `useRef<FileAttachmentsHandler>`)
// so the shell's imperative `fileAttachmentsOnSubmit` / `fileAttachmentsOnClose`
// handles can flush the queued attachments at submit/close time — without the
// shared ref, attachments added on create are never uploaded.
export function FileAttachmentsPanel(): JSX.Element {
  const { defaultProject, fileAttachmentsRef } = useProjectFormV2Context();
  const formMethods = useFormContext<ProjectFormSchemaInterface>();

  return (
    <Card sx={{ p: 2, mb: 2 }}>
      <FileAttachments
        ref={fileAttachmentsRef}
        fileAttachableId={defaultProject?.id}
        fileAttachableType={FileAttachableType.PROJECT}
        control={formMethods.control}
        errors={formMethods.formState.errors}
        form={formMethods}
        name="fileAttachments"
      />
    </Card>
  );
}
